import { ComponentType } from 'react'
import styled from 'styled-components'
import { AboutNav } from 'views/common/about-nav'
import { Admins } from './admins'
import { TextHero } from 'components/TextHero'
import { Intro } from './intro'
import { Rents } from './rents'
import { Sales } from './sales'

const SectionsWrapper = styled.div`
  padding: 44px 0;
`

export const AgentsDesktop: ComponentType = () => (
  <>
    <TextHero title="Conoce Mérida, Descubre Yucatán" subtitle="Asesores Certificados" />
    <AboutNav />
    {/*<Intro />*/}
    <SectionsWrapper>
      <Sales />
      <Rents />
      <Admins />
    </SectionsWrapper>
  </>
)
